import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './watch/Header';
import Footer from './watch/Footer';
import Home from './watch/Home';
import Collection from './watch/Collection';
import Service from './watch/Service';
import Journal from './watch/Journal';
import Visit from './watch/Visit';

// Vermillion Horology — multi-page Signature template ($1,000 tier).
// Internal state-driven router (no URL changes) so the live-preview
// wrapper continues to work and visitors stay inside the template.
export default function WatchTemplate() {
  const [page, setPage] = useState('home');

  // Scroll to top on page change so the editorial reading experience
  // starts fresh — and force serif font stack for the whole template
  // without polluting the rest of the app.
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [page]);

  return (
    <div
      className="min-h-screen bg-[#F2EBDA] antialiased"
      data-testid="watch-template-root"
    >
      <Header page={page} setPage={setPage} />

      <AnimatePresence mode="wait">
        <motion.main
          key={page}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -4 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          data-testid={`watch-page-${page}`}
        >
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'collection' && <Collection setPage={setPage} />}
          {page === 'service' && <Service setPage={setPage} />}
          {page === 'journal' && <Journal setPage={setPage} />}
          {page === 'visit' && <Visit setPage={setPage} />}
        </motion.main>
      </AnimatePresence>

      <Footer setPage={setPage} />
    </div>
  );
}
